/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  deposit: [],
  withdraw: [],
  popup:false,
  popup2:false,
  popup4:false,
  selected:[],
  field:{},
  slip:[],
  index:null,
  items:[],
  userId:{code:'',key:''},
  slip_selected:[],
  credit:[],
}
